import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import loader from '../../../../assets/svgs/load.svg';
import { Typography } from '../../../style/Typography';

type NoteLoadingProps = {
  text: string;
  coverModal: boolean;
};

const NoteLoading: FC<NoteLoadingProps> = ({ text, coverModal }): JSX.Element => {
  return (
    <LoadingContainer data-testid='note-loading' coverModal={coverModal}>
      <LoadingParagraph>
        <Image src={loader} alt='Loading' />
        <Typography size={theme.typography.h2} marginLeft={5} color={theme.palette.grayTwo}>
          {text}
        </Typography>
      </LoadingParagraph>
    </LoadingContainer>
  );
};

type ImageProps = {
  src: string;
  alt: string;
};

const Image = styled.img.attrs<ImageProps>((props) => ({
  src: props.src,
  alt: props.alt,
}))<ImageProps>`
  max-height: 60px;
  vertical-align: top;
`;

interface LoadingContainerProps {
  coverModal: boolean;
}

const LoadingContainer = styled.div<LoadingContainerProps>`
  margin: 0;
  padding-top: 0;
  text-align: center;
  position: ${(props) => (props.coverModal ? 'absolute' : 'relative')};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.9);
  z-index: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 100px;
  border-top: 1px solid ${theme.palette.backgroundGray};
  border-radius: 6px;
`;

const LoadingParagraph = styled.p`
  line-height: 1;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  [src*='svg'] {
    width: 60px;
    animation: glow 1s infinite;
    vertical-align: bottom;
    margin-right: 5px;
  }

  &:after {
    content: '.';
    animation: dots 1s steps(5, end) infinite;
  }
  @keyframes dots {
    0%,
    20% {
      color: rgba(102, 102, 102, 0);
      text-shadow:
        0.25em 0 0 rgba(102, 102, 102, 0),
        0.5em 0 0 rgba(102, 102, 102, 0);
    }

    40% {
      color: #676767;
      text-shadow:
        0.25em 0 0 rgba(102, 102, 102, 0),
        0.5em 0 0 rgba(102, 102, 102, 0);
    }

    60% {
      text-shadow:
        0.25em 0 0 #676767,
        0.5em 0 0 rgba(102, 102, 102, 0);
    }

    80%,
    100% {
      text-shadow:
        0.25em 0 0 #676767,
        0.5em 0 0 #676767;
    }
  }

  @keyframes glow {
    0% {
      opacity: 0.2;
    }

    50% {
      opacity: 1;
    }

    100% {
      opacity: 0.2;
    }
  }
`;

export default NoteLoading;
